import { IPhuHuynhUpdateInfoRequest } from "../models/request/phu-huynh/IPhuHuynhUpdateInfoRequest";
import { IParentBaseInformation } from "../models/request/acceptance-form/IParentBaseInformation";
import { apiClient } from "./apiClient";
import { apiGuestClient } from "./apiGuestClient";
import { IUpdateNguoiPhuTrachRequest } from "../models/request/phu-huynh/IUpdateNguoiPhuTrachRequest ";

export const phuHuynhApi = {
    SelectByHocSinhQuanHeGiaDinh: (ts_hocsinh_id: number, ts_quanhegiadinh_id:number ) => apiClient.get(`phu-huynh/hocsinh/${ts_hocsinh_id}/quanhegiadinh/${ts_quanhegiadinh_id}`),

    SelectAll: (dm_coso_id: number, ts_phuhuynh_adm_status_id:number, dm_chiendich_id :number ) => apiClient.get(`phu-huynh/coso/${dm_coso_id}/status/${ts_phuhuynh_adm_status_id}/chiendich/${dm_chiendich_id}`),

    getById: (id: number) => 
        apiClient.get(`phu-huynh/${id}`),

    delete: (id: number) => 
        apiClient.delete(`phu-huynh/${id}`),

    updateInfo: (request: IPhuHuynhUpdateInfoRequest) =>
        apiClient.put(`phu-huynh`, request),
    insertInfo: (request: IPhuHuynhUpdateInfoRequest) =>
        apiClient.post(`phu-huynh`, request),
    selectFamily: (id: number) => 
        apiClient.get(`phu-huynh/${id}/family`),
    selectLichSuDangKy: (id: number) => 
        apiClient.get(`phu-huynh/${id}/lich-su-dang-ky`),
    SelectParentsByHocSinh: (ts_hocsinh_id: number) => apiGuestClient.get(`phu-huynh/hoc-sinh/${ts_hocsinh_id}`),
    UpdateParentsInfomation: (data: IParentBaseInformation[]) => apiGuestClient.put(`phu-huynh/parents-information`, data),

    
    GetUsersWithADMRoles: () => 
        apiClient.get(`phu-huynh/GetUsersWithADMRoles`),
    updateNguoiPhuTrach: (request: IUpdateNguoiPhuTrachRequest) =>
        apiClient.put(`phu-huynh/update-nguoi-phu-trach`, request),
}

